import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildLoginRequest } from '../lib/msal-config.js';

interface LocationState {
  from?: string;
}

/**
 * Sign-in page. Shows the "Sign in with Microsoft" button while
 * unauthenticated; redirects back to the originating route (or `/`) once
 * MSAL reports authenticated.
 */
export function Login(): JSX.Element {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as LocationState | null)?.from ?? '/';

  useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, from, navigate]);

  const handleSignIn = (): void => {
    void instance.loginRedirect(buildLoginRequest());
  };

  return (
    <section className="mx-auto mt-16 max-w-md px-4">
      <div className="rounded-lg border border-gray-200 bg-white p-8 text-center shadow-sm dark:border-gray-700 dark:bg-gray-800">
        <img
          src="/workfocus-logo-small.svg"
          alt="WorkFocus"
          height={48}
          width={48}
          className="mx-auto mb-4"
        />
        <h1 className="mb-2 text-2xl font-bold text-gray-900 dark:text-gray-100">Sign in</h1>
        <p className="mb-6 text-sm text-gray-600 dark:text-gray-400">
          Sign in with your WorkFocus Microsoft account to access the Admin Console.
        </p>
        <button
          type="button"
          onClick={handleSignIn}
          className="inline-flex w-full items-center justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700"
        >
          Sign in with Microsoft
        </button>
      </div>
    </section>
  );
}
